import React from "react";
import "../index.css";
import photo from "../img/papa-img.jpg";
import qr from "../img/qr.png";

export default function MainRu() {
    const currentYear = new Date().getFullYear();

    return (
        <>
            <div className="contact-icons">
                {/* Telegram */}
                <a
                    href="https://t.me/Michael_Kern"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="Btn"
                >
                    <span className="BG"></span>
                    <span className="svgContainer">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 496 512"
                            fill="white"
                        >
                            <path d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm107.3 164.2l-37.4 176.4c-2.8 12.6-10.2 15.7-20.7 9.8l-57.3-42.2-27.6 26.6c-3 3-5.5 5.5-11.2 5.5l4-57.5 104.9-94.8c4.6-4.2-1-6.6-7.1-2.4l-129.6 81.5-55.9-17.5c-12.2-3.8-12.5-12.2 2.5-18.1l216.9-83.7c10-3.7 18.7 2.4 15.4 18.9z" />
                        </svg>
                    </span>
                </a>

                {/* Facebook */}
                <a
                    href="https://www.facebook.com/share/16PpiGPKXm/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="Btnstock"
                >
                    <span className="BGstock"></span>
                    <span className="svgContainerstock">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 320 512"
                            fill="white"
                        >
                            <path d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S293.2 0 262.39 0c-73.22 0-121.17 44.38-121.17 124.72v70.62H89.09V288h52.13v224h100.17V288z" />
                        </svg>
                    </span>
                </a>

                {/* Instagram */}
                <a
                    href="https://instagram.com/michail_kern"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="Btninsta"
                >
                    <span className="BGinsta"></span>
                    <span className="svgContainerinsta">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 448 512"
                            fill="white"
                        >
                            <path d="M224.1 141c-63.6 0-115 51.5-115 115.1s51.4 115 115 115 115-51.5 115-115.1-51.5-115-115-115zm0 190.2c-41.6 0-75.2-33.6-75.2-75.1s33.6-75.1 75.2-75.1 75.2 33.6 75.2 75.1-33.6 75.1-75.2 75.1zm146.4-194.3c0 14.9-12 26.9-26.9 26.9s-26.9-12-26.9-26.9 12-26.9 26.9-26.9 26.9 12 26.9 26.9zm76.1 27.2c-1.7-35.7-9.9-67.3-36.2-93.5S371.8 7.6 336.1 5.9C298.7 3.9 149.3 3.9 111.9 5.9 76.2 7.6 44.6 15.8 18.3 42.1S7.6 76.2 5.9 111.9C3.9 149.3 3.9 298.7 5.9 336.1c1.7 35.7 9.9-67.3 36.2 93.5s57.8 34.5 93.5 36.2c37.4 2 186.8 2 224.2 0 35.7-1.7 67.3-9.9 93.5-36.2s34.5-57.8 36.2-93.5c2-37.4 2-186.8 0-224.2z" />
                        </svg>
                    </span>
                </a>
            </div>

            {/* ✅ ФОТО — ПЕРЕД ПЕРЕКЛЮЧАТЕЛЕМ ЯЗЫКА */}
            <div className="photo-wrapper">
                <div className="stack">
                    <div className="photo-card">
                        <img src={photo} alt="Michael Kernatsenskii" className="image" />
                    </div>
                </div>
            </div>

            {/* ✅ ПЕРЕКЛЮЧАТЕЛЬ ЯЗЫКА — ПОД ФОТО */}
            <div className="lang-switch-wrapper">
                <a
                    href="/"
                    className="
                        relative cursor-pointer py-3 px-7
                        inline-flex justify-center items-center
                        text-sm uppercase font-semibold tracking-wider
                        text-[#3a2f00]
                        rounded-lg
                        transition-transform duration-300 ease-in-out
                        group overflow-hidden
                        bg-gradient-to-br from-yellow-400 to-amber-500
                        hover:scale-[1.03] shadow-lg
                    "
                >
                    <span className="relative z-20">RU</span>

                    <span
                        className="
                            absolute left-[-75%] top-0 h-full w-[50%]
                            bg-white/40 rotate-12 blur-lg
                            group-hover:left-[125%]
                            transition-all duration-1000 ease-in-out
                        "
                    />

                    <span className="absolute top-0 left-0 w-1/2 h-[20%] border-l-2 border-t-2 border-yellow-200 rounded-tl-lg" />
                    <span className="absolute top-0 right-0 w-1/2 h-[60%] group-hover:h-[90%] border-r-2 border-t-2 border-yellow-200 rounded-tr-lg transition-all duration-300" />
                    <span className="absolute bottom-0 left-0 w-1/2 h-[60%] group-hover:h-[90%] border-l-2 border-b-2 border-yellow-200 rounded-bl-lg transition-all duration-300" />
                    <span className="absolute bottom-0 right-0 w-1/2 h-[20%] border-r-2 border-b-2 border-yellow-200 rounded-br-lg" />
                </a>
            </div>

            {/* ✅ QR — ПОСЛЕ ПЕРЕКЛЮЧАТЕЛЯ */}
            <div className="qr-main-wrapper">
                <a href="/card" className="qr-glass-card" aria-label="Open card" title="Card">
                    <img src={qr} alt="QR code" className="qr-main-img" />
                </a>
            </div>

            <div className="container">
                <section className="section">
                    <div className="card">
                        <h2 className="card-title">Über mich</h2>
                        <div className="card-text">
                            <p>
                                Freude, Stabilität und Sinn sind keine universellen Formeln, sondern individuelle Wege.
                                Ich begleite Menschen dabei, zu sich selbst zurückzufinden und ein Leben zu gestalten,
                                das sich wirklich wie ihr eigenes anfühlt – in Beziehungen, im Beruf und bei persönlichen Entscheidungen.
                            </p>

                            <p>
                                Ich arbeite seit dem Jahr 2000 als Psychologe und Coach. In dieser Zeit hat sich die Welt mehrfach verändert –
                                und mit ihr auch Anforderungen, Werte und Lebenskontexte. Eines ist in meiner Arbeit jedoch unverändert geblieben:
                                die aufmerksame Hinwendung zum Menschen, der Respekt vor seinem individuellen Weg und die Suche nach der für ihn stimmigsten Lösung.
                            </p>

                            <p>
                                Mein Ansatz ist integrativ. Ich verbinde bewährte Methoden der psychologischen Beratung und des Coachings und passe sie an die konkrete
                                Lebenssituation meiner Klient*innen an. Ich arbeite mit Menschen, die sich in Krisen befinden oder ihren inneren Halt verloren haben,
                                stabile Beziehungen aufbauen möchten, ihre Ziele neu ausrichten oder Unterstützung für sich selbst, ihr Team oder ihr Unternehmen suchen.
                            </p>

                            <p>
                                Meine Aufgabe ist es, Sie dabei zu unterstützen, Ihre inneren Ressourcen wiederzuentdecken und einen Weg einzuschlagen,
                                der von Klarheit, Selbstvertrauen und Lebensfreude getragen ist.
                            </p>
                        </div>
                    </div>

                    <div className="card">
                        <h2 className="card-title">Arbeitsbereiche</h2>
                        <div className="card-text">
                            <p>
                                <strong>Psychische Stabilität und persönliche Entwicklung in Zeiten von Unsicherheit und Krisen</strong>
                                <br />
                                Schwerpunkt auf Anpassungsfähigkeit, innerer Stabilisierung, dem Umgang mit Angst, Erschöpfung und Burnout
                                sowie der Sinnfindung in Phasen des Wandels.
                            </p>

                            <p>
                                <strong>Aufbau gesunder und stabiler Beziehungen</strong>
                                <br />
                                Partnerschaft, Familie, Trennung und Neubeginn, persönliche Grenzen, emotionale Kompetenz,
                                Migrationserfahrungen und bewusste Elternschaft.
                            </p>

                            <p>
                                <strong>Zielklärung und Coaching in Zeiten der Neuorientierung</strong>
                                <br />
                                Neuausrichtung von Zielen und Motivation, Überprüfung von Lebensentwürfen, Umgang mit Veränderungsängsten
                                sowie Entwicklung tragfähiger Zukunftsstrategien.
                            </p>

                            <p>
                                <strong>Psychologische Begleitung von Unternehmer:innen und Teams</strong>
                                <br />
                                Mentale Gesundheit, Teamdynamiken, Burnout-Prävention sowie die Entwicklung einer Kultur von Verantwortung
                                und Fürsorge im beruflichen Kontext.
                            </p>
                        </div>
                    </div>

                    <div className="card">
                        <h2 className="card-title">Praxisadresse</h2>
                        <ul className="card-text">
                            <li>FreiRaumQuadrat</li>
                            <li>C2 20</li>
                            <li>68159 Mannheim</li>
                        </ul>
                    </div>
                </section>

                <footer className="footer">
                    &copy; {currentYear} Michael Kernatsenskii. Alle Rechte sind geschützt.
                </footer>
            </div>
        </>
    );
}
